import * as amplitude from '@amplitude/unified';

/**
 * Centralized Amplitude event tracking for key user actions.
 * All custom event names follow "Noun Action" convention.
 */

export function trackRoomCreated(roomId: string) {
  amplitude.track('Room Created', { room_id: roomId });
}

export function trackContentUploaded(contentId: string, contentType: string) {
  amplitude.track('Content Uploaded', { content_id: contentId, content_type: contentType });
}

export function trackQuizCompleted(quizId: string, score: number, totalQuestions: number, totalCorrect: number) {
  amplitude.track('Quiz Completed', {
    quiz_id: quizId,
    score,
    total_questions: totalQuestions,
    total_correct: totalCorrect,
  });
}

export function trackFlashcardsGenerated(deckId: string, cardCount: number, source: 'chat' | 'content' | 'topic') {
  amplitude.track('Flashcards Generated', {
    deck_id: deckId,
    card_count: cardCount,
    source,
  });
}

export function trackCourseEnrolled(courseId: string) {
  amplitude.track('Course Enrolled', { course_id: courseId });
}

export function trackExamCreated(examId: string, questionCount: number) {
  amplitude.track('Exam Created', { exam_id: examId, question_count: questionCount });
}

export function trackSummaryGenerated(summaryId: string | undefined, template: string) {
  amplitude.track('Summary Generated', { summary_id: summaryId, template });
}

export function trackChatMessageSent(chatId: string) {
  amplitude.track('Chat Message Sent', { chat_id: chatId });
}
